import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { cn } from '../utils/cn';

interface ClickToRevealProps {
  value: string;
  /** Shown while hidden; defaults to a masked placeholder. */
  placeholder?: string;
  /** Accessible label for the reveal button, e.g. "Reveal email". */
  label?: string;
  className?: string;
  /** Applied to the revealed value. */
  valueClassName?: string;
}

/**
 * Sensitive value that stays masked until clicked (emails, IPs). A shared version of the
 * click-to-reveal row in UserInfo.tsx, usable inline in tables and strips.
 */
export const ClickToReveal = ({ value, placeholder = '••••••••', label = 'Reveal', className, valueClassName }: ClickToRevealProps) => {
  const [visible, setVisible] = useState(false);
  return (
    <span className={cn('inline-flex items-center gap-1.5 min-w-0', className)}>
      {visible ? (
        <span className={cn('font-mono text-white truncate', valueClassName)}>{value}</span>
      ) : (
        <span className="font-mono text-glass-500 select-none" aria-hidden="true">
          {placeholder}
        </span>
      )}
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="inline-flex items-center justify-center w-6 h-6 rounded-md text-glass-400 hover:text-white hover:bg-glass-200/10 transition-colors touch-manipulation flex-shrink-0"
        aria-label={visible ? `Hide ${label.toLowerCase()}` : label}
        title={visible ? 'Hide' : label}
      >
        {visible ? <EyeOff className="w-3.5 h-3.5" /> : <Eye className="w-3.5 h-3.5" />}
      </button>
    </span>
  );
};
